<ion-header #header>
  <ion-toolbar color="light">
    <ion-buttons slot="start">
      <ion-button (click)="goBack()" *ngIf="showBackButton">
        <ion-icon class="back-icon" name="chevron-back"></ion-icon>
      </ion-button>
      <ion-menu-button *ngIf="!showBackButton">
        <ion-icon class="icon-menu" name="menu"></ion-icon>
        <app-inbox-count></app-inbox-count>
      </ion-menu-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      {{ 'QRCODE.btn.scan' | translate }}
    </ion-title>
    <ion-buttons slot="end" *ngIf="scanMode === 'camera' && torchAvailable">
      <ion-button (click)="toggleTorch(torchEnabled)">
        <ion-icon name="flashlight" *ngIf="torchEnabled"></ion-icon>
        <ion-icon name="flashlight-outline" *ngIf="!torchEnabled"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end" *ngIf="scanMode === 'scanner'">
      <ion-button fill="outline" [color]="autoFocus ? 'danger' : 'success'" (click)="toggleAutoFocus(autoFocus)">
        <ng-container *ngIf="!autoFocus">{{ 'LBL.start' | translate }}</ng-container>
        <ng-container *ngIf="autoFocus">{{ 'LBL.stop' | translate }}</ng-container>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar *ngIf="type === 'checkin' && isHybrid">
    <ion-segment class="full-width" scrollable [(ngModel)]="scanMode" (ionChange)="modeChanged()">
      <ion-segment-button value="camera">
        <ion-label>{{ 'SCAN.method.camera' | translate }}</ion-label>
      </ion-segment-button>
      <ion-segment-button value="scanner">
        <ion-label>{{ 'SCAN.method.scanner' | translate }}</ion-label>
      </ion-segment-button>
    </ion-segment>
  </ion-toolbar>
</ion-header>
<ion-content class="full-width" [class]="scanMode === 'camera' ? 'background-transparent' : ''" [style.height]="pageMode ? contentHeight : '100%'">
  <ng-container *ngIf="scanMode !== 'scanner'">
    <ng-container>
      <div class="scan-header background">
        <div class="ion-padding">
          <div class="ion-text-center ion-padding">
            <ion-text class="font-semi" color="dark">
              <ng-container *ngIf="type === 'accounts'">{{ 'SCAN.accounts.intro_title' | translate }}</ng-container>
              <ng-container *ngIf="type === 'checkin'">{{ 'SCAN.checkin.intro_title' | translate }}</ng-container>
            </ion-text>
          </div>
          <div class="ion-text-center ion-padding">
            <ion-text class="font-14" color="dark">
              <ng-container *ngIf="type === 'accounts'">{{ 'SCAN.accounts.intro_msg' | translate }}</ng-container>
              <ng-container *ngIf="type === 'checkin'">{{ 'SCAN.checkin.intro_msg' | translate }}</ng-container>
            </ion-text>
          </div>
        </div>
      </div>
      <div class="scan-content">
        <div class="scan-side background"></div>
        <div class="scan-window ion-no-padding ion-no-margin">
          <div class="animate-frame" *ngIf="ready"></div>
          <ion-icon class="scan-window ion-no-padding ion-no-margin" color="primary" src="./assets/wedding/icon/qrcode/scanner-frame.svg"></ion-icon>
        </div>
        <div class="scan-side background"></div>
      </div>
      <div class="scan-footer background">
      </div>
    </ng-container>
  </ng-container>
  <div class="content-div" *ngIf="scanMode === 'scanner'">
    <div class="full-width-height vertical-center ion-padding">
      <div class="full-width ion-text-center ion-padding">
        <ion-text class="font-semi" color="dark">
          {{ 'SCAN.scanner.intro_title' | translate }}
        </ion-text>
      </div>
      <div class="ion-text-center ion-padding">
        <ion-text class="font-14" color="dark">
          {{ 'SCAN.scanner.intro_msg' | translate }}
        </ion-text>
      </div>
      <form class="full-width ion-padding-vertical" [formGroup]="form" (ngSubmit)="formSubmit()">
        <ion-item class="prompt-input-item" lines="none">
          <ion-input name="scannerResult" formControlName="scannerResult" (ionInput)="formSubmit()" (ionBlur)="setFocus()" debounce="800" enterkeyhint="search" inputmode="search" type="text" autocomplete="off" showClearButton="never" searchIcon="search-outline" #input></ion-input>
        </ion-item>
      </form>
      

      <!-- <form class="full-width" [formGroup]="form" (ngSubmit)="formSubmit()" *ngIf="form">
        <ion-item class="prompt-input-item" lines="none">
          <ion-input formControlName="scannerResult" (ionBlur)="setFocus()" inputmode="text" autofocus="true" enterkeyhint="search" required #input></ion-input>
        </ion-item>
        <div class="error-div">
          <ng-container *ngFor="let validation of validationMsg?.scannerResult">
            <div class="error-message" *ngIf="form?.get('scannerResult').hasError(validation.type) && (form?.get('scannerResult').dirty || form?.get('scannerResult').touched)">
              <ion-icon name="alert-circle-outline"></ion-icon> {{ validation.msg }}
            </div>
          </ng-container>
        </div>
      </form> -->
    </div>
  </div>

</ion-content>
